<template>
  <div class="bannerskip-container">
    <el-select
      ref="select"
      v-model="value"
      placeholder="请选择跳转目标，可输入关键字搜索"
      filterable
      clearable
      prefix-icon="el-icon-search"
      :filter-method="searchCourse"
      :disabled="disabled"
      :style="tcfstyle"
      @clear="clearSelect"
    >
      <el-option :value="value" :label="changeLabel" style="height: auto;padding: 0;">
        <el-table
          :data="tableData"
          :show-header="false"
          style="width: 100%"
          @row-click="openDetails">
          <el-table-column
            label="活动名称"
            min-width="500">
            <template slot-scope="scope">
              <span style="margin-left: 10px;font-weight: normal">{{ scope.row.name }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-option>
      <el-pagination
        v-if="total>0"
        style="padding:10px"
        background
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="total"
        @current-change="handleCurrentChange"
      />
    </el-select>
  </div>
</template>

<script>
import { getDelLiveList, getDelOfflineList, getDelOfflineInfo, getDelLiveInfo } from '@/api/dealer'
import { getCaseList, getCaseInfo, getShowHomeList, getShowHomeInfo, getStrategyPC, getStrategyInfo } from '@/api/community'
import { getUser } from '@/utils/auth'
import { getDealerDetail } from '@/api/work'

export default {
  name: 'Bannerskipselect',
  props: {
    selecttype: {
      type: Number
    },
    olddataid: {
      type: Number
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tcfstyle: {
      type: String,
      default: 'width: 100%'
    }
  },
  data() {
    return {
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 5,
      total: 0,
      filterText: '',
      value: '',
      changeLabel: '',
      type: null,
      bid: 0,
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.getBrandList()
    this.type = this.selecttype
    if (this.olddataid !== null && this.olddataid !== '' && this.olddataid !== undefined && this.olddataid !== 0) {
      if (this.selecttype === 3) {
        this.getOfflineInfo()
      } else if (this.selecttype === 4) {
        this.getLiveInfo()
      } else if (this.selecttype === 5) {
        this.getCaseInfo()
      } else if (this.selecttype === 6) {
        this.getStrategyInfo()
      } else if (this.selecttype === 7) {
        this.getShowHomeInfo()
      }
    }
  },
  methods: {
    getBrandList() {
      getDealerDetail({ delid: this.user.delid }).then(response => {
        if (response.data.brandlst.length > 0) {
          this.bid = response.data.brandlst[0].bid
        }
        this.getData()
      })
    },
    getOffLine() {
      const data = {
        delid: this.user.delid,
        page: this.currentPage,
        limit: this.pageSize,
        mark: 1,
        search: this.filterText
      }
      getDelOfflineList(data).then(response => {
        this.loading = false
        this.total = response.total
        const offline = []
        response.data.forEach(row => {
          offline.push({
            name: row.name,
            dataid: row.doid
          })
        })
        this.tableData = offline
      }).catch(() => {
        this.loading = false
      })
    },
    getOfflineInfo() {
      getDelOfflineInfo({ doid: this.olddataid }).then(response => {
        this.value = response.data.doid
        this.changeLabel = response.data.name
        this.$emit('input', { dataid: response.data.doid, name: response.data.name })
      })
    },
    getLive() {
      const data = {
        delid: this.user.delid,
        page: this.currentPage,
        limit: this.pageSize,
        search: this.filterText
      }
      getDelLiveList(data).then(response => {
        this.loading = false
        this.total = response.total
        const live = []
        response.data.forEach(row => {
          live.push({
            name: row.name,
            dataid: row.dlid
          })
        })
        this.tableData = live
      }).catch(() => {
        this.loading = false
      })
    },
    getLiveInfo() {
      getDelLiveInfo({ dlid: this.olddataid }).then(response => {
        this.value = response.data.dlid
        this.changeLabel = response.data.name
        this.$emit('input', { dataid: response.data.dlid, name: response.data.name })
      })
    },
    getCase() {
      const data = {
        page: this.currentPage,
        limit: this.pageSize,
        brand: this.bid,
        search: this.filterText,
        delid: this.user.delid
      }
      getCaseList(data).then(response => {
        this.loading = false
        this.total = response.total
        const cases = []
        response.data.forEach(row => {
          cases.push({
            name: row.title,
            dataid: row.cid
          })
        })
        this.tableData = cases
      }).catch(() => {
        this.loading = false
      })
    },
    getCaseInfo() {
      getCaseInfo({ cid: this.olddataid }).then(response => {
        this.value = response.data.cid
        this.changeLabel = response.data.title
        this.$emit('input', { dataid: response.data.cid, name: response.data.title })
      })
    },
    getShowHome() {
      const data = {
        page: this.currentPage,
        limit: this.pageSize,
        search: this.filterText,
        brand: this.bid,
        delid: this.user.delid
      }
      getShowHomeList(data).then(response => {
        this.loading = false
        this.total = response.total
        const showhome = []
        response.data.forEach(row => {
          showhome.push({
            name: row.title,
            dataid: row.shid
          })
        })
        this.tableData = showhome
      }).catch(() => {
        this.loading = false
      })
    },
    getShowHomeInfo() {
      getShowHomeInfo({ sid: this.olddataid }).then(response => {
        this.value = response.data.shid
        this.changeLabel = response.data.title
        this.$emit('input', { dataid: response.data.shid, name: response.data.title })
      })
    },
    getStrategy() {
      const data = {
        page: this.currentPage,
        limit: this.pageSize,
        search: this.filterText
      }
      getStrategyPC(data).then(response => {
        this.loading = false
        this.total = response.total
        const strategy = []
        response.data.forEach(row => {
          strategy.push({
            name: row.title,
            dataid: row.sid
          })
        })
        this.tableData = strategy
      }).catch(() => {
        this.loading = false
      })
    },
    getStrategyInfo() {
      getStrategyInfo({ sid: this.olddataid }).then(response => {
        this.value = response.data.sid
        this.changeLabel = response.data.title
        this.$emit('input', { dataid: response.data.sid, name: response.data.title })
      })
    },
    getData() {
      this.loading = true
      if (this.type === 3) {
        this.getOffLine()
      } else if (this.type === 4) {
        this.getLive()
      } else if (this.type === 5) {
        this.getCase()
      } else if (this.type === 6) {
        this.getStrategy()
      } else if (this.type === 7) {
        this.getShowHome()
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    clearSelect() {
      this.filterText = ''
      this.value = ''
      this.changeLabel = ''
      this.$emit('input', null)
    },
    searchCourse(val) {
      this.filterText = val
      this.getData()
    },
    openDetails(data) {
      this.value = data.dataid
      this.changeLabel = data.name
      this.$emit('input', { dataid: data.dataid, name: data.name })
      // this.$emit('setCourse', data)
      this.$refs.select.blur()
    }
  }
}
</script>

<style lang="scss" scoped>
  .bannerskip-container{
    .el-table::before{
      height: 0!important;
    }
    .el-pagination{
      margin-top: 20px;
    }
  }
</style>
